import { forwardRef } from 'react';

import { styled } from '@eneco/sparky/stitches';
import { TransformStitchesToSparky } from '@eneco/sparky/types';
import * as Separator from '@radix-ui/react-separator';

const VerticalDividerStyled = styled(Separator.Root, {
  display: 'block',
  decorative: true,
  width: '$borderWidths$s',

  variants: {
    emphasis: {
      low: {
        backgroundColor: '$borderDividerLowEmphasis',
      },
      medium: {
        backgroundColor: '$borderDividerMediumEmphasis',
      },
      high: {
        backgroundColor: '$borderDividerHighEmphasis',
      },
    },
  },

  defaultVariants: {
    emphasis: 'low',
  },
});

interface Props extends TransformStitchesToSparky<typeof VerticalDividerStyled> {
  className?: never;
}

const stitchesClassName = 'sparky-divider';

export const VerticalDivider = forwardRef<HTMLDivElement, Props>(({ className = '', ...props }, ref) => {
  return <VerticalDividerStyled ref={ref} className={`${stitchesClassName} ${className}`} {...props} />;
});

VerticalDivider.toString = () => `.${stitchesClassName}`;
VerticalDividerStyled.displayName = 'styled(VerticalDivider)';
VerticalDivider.displayName = 'VerticalDivider';
